import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const postDrug = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/create-drug`,
  method: 'post',
  form
});

export const searchDrugsByGTIN = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-information?gtin=${query}`,
  method: 'get'
});


export const editDrug = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/edit-drug`,
  method: 'put',
  data
});
export const editUnregisteredDrug = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/edit-unregistered-drug`,
  method: 'put',
  data
});

export const searchStakeholder = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/search-stakeholder?GlnORName=${query}`,
  method: 'get'

});
export const cityList = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}api/Portal/Drug/duplicate?gtin=06281080010910`,
  method: 'get'

});
export const duplicateDrug = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/create-drug`,
  method: 'get',
  data

});

export const getDrug = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-information?gtin=${data}`,
  method: 'get'
});

export const unregisteredDrugInformation = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/unregistered-drug-information?gtin=${data}`,
  method: 'get'
});

export const getSMPDrug = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/smp-unregistered-drug-information?drugId=${id}`,
  method: 'get'
});

export const searchDrugs = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/Drug/drug-list`,
  method: 'get',
  query
});

export const searchDrugRequests = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/mp-drug-requests`,
  method: 'get',
  query
});

export const searchDrugHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/drug-requests-history`,
  method: 'get',
  query
});

export const SMPSearchDrugs = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/Drug/smp-drug-list`,
  method: 'get',
  query
});

export const sopSearchDrugs = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/sop-drug-list`,
  method: 'get',
  query
});

export const searchDrugMLimitation = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugSaleLimitation/drug-sale-limitation-list`,
  method: 'get',
  query
});

export const searchDrugsByNameGTIN = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/DrugSaleLimitation/drug-by-name-gtin`,
  method: 'get',
  query
});
export const searchDrug = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/DrugSaleLimitation/search-drug`,
  method: 'get',
  query
});

export const searchDrugsByNameSearchKey = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-info-name-gtin?searchKey=${query}`,
  method: 'get'
});

export const addDrugMLimitation = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/DrugSaleLimitation/drug-sale-limitation`,
  method: 'post',
  data
});

export const editDrugMLimitation = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/DrugSaleLimitation/drug-sale-limitation`,
  method: 'post',
  data
});


export const drugStakeholderHistoryList = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-stakeholder-history-list`,
  method: 'get',
  query: {
    'param.page': 0,
    'param.perPage': 9,
    drugId: id
  }
});

export const drugHistoryList = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-history-list`,
  method: 'get',
  query: {
    'param.page': 0,
    'param.perPage': 9,
    drugId: id
  }
});
export const drugCountOverStakeholderType = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/drug-count-over-stakeholder-type`,
  method: 'get',
  query
});
export const drugCountOverStakeholder = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/drug-count-over-stakeholder`,
  method: 'get',
  query
});

export const sopUnitList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}report-service/api/portal/Units/unit-list`,
  method: 'get',
  query
});

export const sopDrugCountOverStakeholder = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/sop-drug-count-over-stakeholder`,
  method: 'get',
  query
});

export const QuantityReceivePending = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/sop-stakeholder-pending-receive-stock-batch-details`,
  method: 'get',
  query
});

export const QuantitySentPending = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/sop-stakeholder-pending-send-stock-batch-details`,
  method: 'get',
  query
});

export const drugListOverStakeholder = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/drug-list-over-stakeholder`,
  method: 'get',
  query
});
export const drugStakeholderList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Reporting/drug-stakeholder-list`,
  method: 'get',
  query
});

export const getCountriesList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/country-list`,
  method: 'get',
  query
});

export const searchSOPShortageReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/sop-drug-shortage-list`,
  method: 'get',
  query
});

export const searchSOPShortageHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-history-list`,
  method: 'get',
  query
});

export const submitSOPShortage = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage`,
  // path: `${REACT_APP_RSD_DOMAIN}demand-and-offer-service/api/portal/DrugShortage/drug-shortage`,
  method: 'post',
  data
});

export const shortageById = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-by-id/${query}`,
  method: 'get'
});

export const approveDrugShortage = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-approve`,
  method: 'post',
  data
});
export const rejectDrugShortage = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-reject`,
  method: 'post',
  data
});

export const assingToUser = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-assign-to-user`,
  method: 'post',
  data
});

export const shortageHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-history-list`,
  method: 'get',
  query
});

export const drugHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/drug-history-list`,
  method: 'get',
  query
});
export const smpStakeholderList = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/smp-stakeholder-list`,
  method: 'get'
});
export const smpDrugStakeholderList = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/smp-drug-stakeholder-list`,
  method: 'get',
  query
});

export const gtinStakeholder = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/gtin-stakeholder`,
  method: 'put',
  data
});

export const searchGenericName = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/search-generic-name`,
  method: 'get',
  query
});

export const ValidateNewGenericName = genericName => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/validate-new-generic-name`,
  method: 'get',
  query: { genericName }
});

export const AddURegisteredDrugsRequest = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/smp-create-drug-request`,
  method: 'post',
  data
});

export const FetchUnregisteredDrubByGTIN = GTIN => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/get-unregistered-drug?gtin=${GTIN}`,
  method: 'get'
});

export const EditUnregisteredDrugsRequest = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/smp-update-drug-request`,
  method: 'put',
  data
});

export const ListUnregisteredDrugRequest = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/smp-drug-requests`,
  method: 'get',
  query
});

export const hasUnregisteredDrugsSubscription = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/has-unregistered-drugs-subscription`,
  method: 'get'
});

export const ViewUnregisteredDrugRequestById = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/drug-requests/${id}`,
  method: 'get'
});

export const UpdateUnregisteredDrugRequestStatus = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/update-status`,
  method: 'post',
  data
});
export const UpdateUnregisteredDrugRequestEstablishments = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/mp-assign-to-drug-requests`,
  method: 'post',
  data
});

export const sopDrugCountWithPendingReceiveStockBatchDetails = query => handleApiRequest({
  path: `${
    REACT_APP_RSD_DOMAIN
  }drug-service/api/portal/Reporting/sop-drug-count-over-stakeholder-with-pending-receive-stock-batch-details`,
  method: 'get',
  query
});

export const searchStakeholdersBySubscriptionType = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/search-stakeholders-by-subscription-type`,
  method: 'get',
  query
});

export const ListPremiumDrugs = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DrugRequest/get-approved-gtins-for-establishment`,
  method: 'get',
  query
});

